export default __webpack_public_path__ + "static/media/keto_fats.d88d88b5.jpg";